import { t } from '@lingui/macro'

import { Markdown } from '@/@bothrs-ui/web/components/markdown/Markdown'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { BookingFlowActions, BookingFlowCenteredContent, BookingFlowLayout } from './BookingFlowLayout'

type InfoSelectProps = {
  content: string
  title?: string
  onNext: () => void
  isLoading: boolean
}

export const InfoSelect = ({ content, title, onNext, isLoading }: InfoSelectProps) => {
  return (
    <BookingFlowLayout>
      <BookingFlowCenteredContent>
        {title && <H3 noMargin>{title}</H3>}
        <Markdown content={content} typography='BodyMediumRegular' />
      </BookingFlowCenteredContent>

      <BookingFlowActions>
        <Button variant='Primary' type='submit' disabled={isLoading} onClick={onNext} isLoading={isLoading}>
          {t({
            id: 'globals.continue',
            message: 'Ga verder',
          })}
        </Button>
      </BookingFlowActions>
    </BookingFlowLayout>
  )
}
